module.exports = __webpack_public_path__ + "img/matt-pro.5e364ba6.jpg";